import { Check } from "lucide-react";
import { STATUSES, slug } from "@/lib/constants";

export const StatusTimeline = ({ status, compact = false }) => {
  const current = STATUSES.indexOf(status);
  const pct = (current / (STATUSES.length - 1)) * 100;

  return (
    <div className="w-full" data-testid="status-timeline">
      <div className="relative">
        <div className="absolute top-4 left-4 right-4 h-[2px] bg-slate-200" />
        <div className="absolute top-4 left-4 h-[2px] bg-[#FF6B00] transition-all duration-700" style={{ width: `calc((100% - 2rem) * ${pct / 100})` }} />
        <ol className="relative grid grid-cols-6 gap-1">
          {STATUSES.map((s, i) => {
            const done = i < current;
            const active = i === current;
            return (
              <li key={s} className="flex flex-col items-center text-center" data-testid={`timeline-step-${slug(s)}`}>
                <span
                  className={`h-8 w-8 rounded-full flex items-center justify-center text-xs font-semibold border-2 transition-colors ${
                    done ? "bg-[#FF6B00] border-[#FF6B00] text-[#070D1E]" : active ? "bg-[#0B132B] border-[#FF6B00] text-[#FF6B00] ring-4 ring-orange-200" : "bg-white border-slate-300 text-slate-400"
                  }`}
                >
                  {done ? <Check className="h-4 w-4" /> : i + 1}
                </span>
                {!compact && (
                  <span className={`mt-2 text-[11px] sm:text-xs leading-tight ${active ? "text-[#0F172A] font-semibold" : done ? "text-slate-600" : "text-slate-400"}`}>{s}</span>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </div>
  );
};
